export { useSalesFunnelColumnComponent } from '@app/components/SalesFunnelColumnComponent/hooks/useSalesFunnelColumnComponent';
